import { createContext, useContext } from 'react';
import type { WhiteLabelConfig } from './whitelabel';
import { getWhiteLabel } from './whitelabel';

const WhiteLabelContext = createContext<WhiteLabelConfig>(getWhiteLabel());

export const WhiteLabelProvider = WhiteLabelContext.Provider;

export function useWhiteLabel(): WhiteLabelConfig {
  return useContext(WhiteLabelContext);
}
